// ── Android hardware back button (Capacitor) ─────────────────────────────────
// Clarity has no router/URL history (tabs are plain React state), so the
// WebView's back-history is always empty and Capacitor's default handling
// would exit the app on the very first back press. Standard "press back
// again to exit" instead. No-ops outside a native build.
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { toast } from 'sonner';

let bound = false;

// Screens with no browser history entry of their own (e.g. the journal note
// editor, opened via plain React state rather than a route) can still claim
// the hardware back button first, ahead of the default "press again to
// exit" handling below. Each entry is a function returning true if it
// handled the press (so the default logic should stop there) or
// false/undefined to fall through. Last-registered (topmost/innermost
// screen) is asked first.
const backHandlers = [];
export function pushBackHandler(fn) {
  backHandlers.push(fn);
  return () => {
    const i = backHandlers.indexOf(fn);
    if (i !== -1) backHandlers.splice(i, 1);
  };
}

export function bindAndroidBackButton() {
  if (bound || !Capacitor.isNativePlatform()) return;
  bound = true;

  let lastPressAt = 0;
  CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    for (let i = backHandlers.length - 1; i >= 0; i--) {
      if (backHandlers[i]()) return;
    }
    if (canGoBack) {
      window.history.back();
      return;
    }
    const now = Date.now();
    if (now - lastPressAt < 2000) {
      CapacitorApp.exitApp();
    } else {
      lastPressAt = now;
      toast('Press back again to exit');
    }
  });
}
